import northImage from '../images/north-elevation.png';

export default function SwitchBrowser() {
    return (
        <>
            <div className="switch-message">
                <div className="bg-white p-4 text-center mt-4 mb-5">
                    <h1>Please switch your browser to Chrome for an optimal experience on this website.</h1>
                    <p>To download the browser, click the button below</p>
                    <a className="btn btn-dark" href="https://www.google.co.uk/chrome/" target="_blank" rel="noreferrer">Download Chrome</a>
                </div>
                <div className="text-center">
                    <img
                        src={northImage}
                        alt="White Tower North Side Wall"
                    />
                </div>
            </div>
        </>
    )
}